// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__hwx2_","titleContainer":"style_titleContainer__LqLRO","icon":"style_icon__1F6zs"};